import React from 'react';
import { Reveal } from './Reveal';
const stats = [['10', 'COMPLETE BOOKS'], ['600', 'PAGES'], ['60', 'LEARNING UNITS'], ['100%', 'READY-TO-TEACH']];
export function StatsBar() {
  return <section className="border-y border-brand-dark bg-brand-alt py-8" data-id="element-147" data-mp="1oam09gfejadw">
      <Reveal className="mx-auto grid max-w-5xl grid-cols-2 gap-y-8 px-4 text-center md:grid-cols-4 md:gap-8" data-id="element-148" data-mp="1jcarl90uf5x9">
        {stats.map(([value, label], index) => <div key={label} className={`flex flex-col items-center justify-center ${index > 0 ? 'md:border-l md:border-brand-dark' : ''}`} data-id="element-149" data-mp="1ee0swofwtn6w" data-mpi={index}>
          <span className="mb-1 font-serif text-3xl font-bold text-brand-blue md:text-4xl" data-id="element-150" data-mp="19ko70m2m7uhu">{value}</span>
          <span className="text-[10px] font-bold uppercase tracking-wider text-brand-gray md:text-xs" data-id="element-151" data-mp="15ijiu2uxrq2l">{label}</span>
        </div>)}
      </Reveal>
    </section>;
}